import { getLocaleWordContent } from '@/utils/language.util';
import { clipboard } from '@/utils/misc.util';
import React from 'react';
import { useState } from 'react';

export default function UserInfor() {
    
    const [recmId, setRecmId] = useState("04712195504017"); 
    const [addr, setAddr] = useState("THa8MV6ijRaRSV1HQfzVQ9BBWNtb6ap1Bq"); 
    
    //setRecmId('04712195504017');

      const handleCopy = (e, copy, title) => {
        console.log("handleCopy", window.location.href)
        clipboard(copy);
        alert(title +'-' + getLocaleWordContent('복사 되었습니다.'));
      }

    return (
        <>
            <div className="bg_balance_left">
                <p className="inner">{getLocaleWordContent('입금계좌')}</p>
                <div className="sp10"></div>
                <div className="inner">
                    <div className="content_box">
                        <div className="box_coin">
                            <p className="gray">{getLocaleWordContent('예금주')}</p>
                            <p className="gray">{getLocaleWordContent('은행명')}</p>
                            <p className="gray">{getLocaleWordContent('계좌번호')}</p>
                            <p className="gray">{getLocaleWordContent('트론 USDT')}</p>
                        </div>
                        <div className="box_coin">
                            <p className="black">{getLocaleWordContent('(주)메가아즈위')} </p>
                            <p className="black">{getLocaleWordContent('기업은행')}</p>
                            <p className="black">{recmId} </p>
                            <p className="black">THa8MV6ij...</p>
                        </div>
                        <div className="box_coin">
                            <p className="black">{'\u00a0'} </p>
                            <p className="black">{'\u00a0'} </p>
                            <p className="black">{'\u00a0'} 
                            <button className="b_orange btn01"  onClick={(e)=>handleCopy(e, recmId, getLocaleWordContent('계좌번호'))}>{getLocaleWordContent('복사')}</button>
                            </p>
                            <p className="black">{'\u00a0'} 
                            <button className="b_orange btn01"  onClick={(e)=>handleCopy(e, addr, getLocaleWordContent('지갑주소'))}>{getLocaleWordContent('복사')}</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="sp20"></div>
            </div>
        </>
    );
}
